import { Stack } from "@mui/material";
import { RatingExplanationHeader } from "@src/appV2/redesign/Tiers/RatingsSection/RatingExplanationHeader";
import { TargetRatingListItem } from "@src/appV2/redesign/Tiers/RatingsSection/TargetRatingListItem";
import { type NormalizedRating, type RatingType } from "@src/appV2/redesign/Tiers/utils/types";

interface RatingExplanationCardProps {
  workerNormalizedRating: NormalizedRating;
  targetNormalizedRating: NormalizedRating;
  header: string;
  ratingType: Exclude<RatingType, "shiftCompletionWithoutLateCancel">;
  onClick: () => void;
}

export function RatingExplanationCard(props: RatingExplanationCardProps) {
  const { workerNormalizedRating, targetNormalizedRating, header, ratingType, onClick } = props;
  return (
    <Stack direction="column" gap={3} sx={{ cursor: "pointer" }} onClick={onClick}>
      <RatingExplanationHeader
        workerNormalizedRating={workerNormalizedRating}
        targetNormalizedRating={targetNormalizedRating}
        header={header}
        onClick={onClick}
      />
      <Stack direction="column" gap={2}>
        <TargetRatingListItem
          workerNormalizedRating={workerNormalizedRating}
          targetNormalizedRating={targetNormalizedRating}
          ratingType={ratingType}
        />
      </Stack>
    </Stack>
  );
}
